module.exports = __webpack_public_path__ + "img/0615df6b893d17b0eb70b0abaedbb7cc.png";